import { isRussia, isUS } from 'env'
import _ from 'lodash'
import { DealStatusTypes, DealType, ListDeal } from 'modules/domain/deal/types'
import { ContractTag } from 'views/pages/Deal/DealDetail/DealTags/ContractTag'
import { ContributionMarginTag } from './ContributionMarginTag'
import { DaysSinceStatusChangeTag } from './DaysSinceStatusChangeTag'
import { DirectorTag } from './DirectorTag'
import { DocumentsTag } from './DocumentsTag'
import { PositionTag } from './PositionTag'
import { SampleTag } from './SampleTag'
import { SpecificationTag } from './SpecificationTag'
import { Tag1C } from './Tag1C'
import { LogisticianManagerTag } from './LogisticianManagerTag'
import { LogisticianManagerFinalTag } from './LogisticianManagerFinalTag'
import { isStatusAfter, isStatusBefore } from '../helpers'

interface tagDataItem {
  render: (deal: ListDeal, key: any) => JSX.Element
  isVisible: (deal: ListDeal) => boolean
}

export const useTags = (): tagDataItem[] => {
  const tags = [
    {
      render: (deal, key) => <DaysSinceStatusChangeTag deal={deal} key={key} />,
      isVisible: (deal: ListDeal) => !_.isNil(deal.days_since_latest_status_change),
    },
    {
      render: (deal) => <PositionTag deal={deal} />,
      isVisible: () => isUS,
    },
    {
      render: (deal, key) => <SampleTag deal={deal} key={key} />,
      isVisible: (deal: ListDeal) => deal.status === DealStatusTypes.IN_PROGRESS,
    },
    {
      render: (deal, key) => <DirectorTag deal={deal} key={key} />,
      isVisible: (deal: ListDeal) => isRussia && deal.status === DealStatusTypes.AGREED,
    },
    {
      render: (deal, key) => <DocumentsTag deal={deal} key={key} />,
      isVisible: (deal: ListDeal) => isRussia && deal.status === DealStatusTypes.CONTRACT_SIGNED,
    },
    {
      render: (deal, key) => <LogisticianManagerTag deal={deal} key={key} />,
      isVisible: (deal: ListDeal) =>
        deal.deal_type !== DealType.railway && deal.status === DealStatusTypes.NEW && isRussia,
    },
    {
      render: (deal, key) => <LogisticianManagerFinalTag deal={deal} key={key} />,
      isVisible: (deal: ListDeal) => deal.status === DealStatusTypes.CUSTOMER_NEGOTIATIONS && isRussia,
    },
    {
      render: (deal, key) => <SpecificationTag deal={deal} key={key} />,
      isVisible: (deal: ListDeal) =>
        isRussia && (deal.status === DealStatusTypes.AGREED || deal.status === DealStatusTypes.CONTRACT_SIGNED),
    },
    {
      render: (deal, key) => <Tag1C deal={deal} key={key} />,
      isVisible: (deal: ListDeal) => isRussia && deal.status === DealStatusTypes.SHIPMENT_COMPLETE,
    },
    {
      render: (deal, key) => <ContractTag deal={deal} key={key} />,
      isVisible: (deal: ListDeal) =>
        isStatusAfter(deal.status, DealStatusTypes.IN_PROGRESS) && isStatusBefore(deal.status, DealStatusTypes.AGREED),
    },
    {
      render: (deal, key) => <ContributionMarginTag deal={deal} key={key} />,
      isVisible: (deal: ListDeal) => isRussia && deal.status === DealStatusTypes.SHIPMENT_COMPLETE,
    },
  ]

  return tags
}
